import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { DecisionMakerConfigsQuery, DecisionMakerConfigsQueryVariables } from './decisionMakerConfigs.graphql';
import { DecisionMakerConfigs } from './decisionMakerConfigs.graphql';

export const getDecisionMakerConfigs = async ({ gql: { fetch } }: UtilityContext) => {
	const {
		data: {
			featureConfigs: {
				decisionMakersLegislativeBodies,
				dmWithLegislativeBodiesConnectionEnabled,
				petitionPageContactDm,
			},
		},
	} = await fetch<DecisionMakerConfigsQuery, DecisionMakerConfigsQueryVariables>({
		query: DecisionMakerConfigs,
		rejectOnError: true,
	});

	const contactDmConfig = {
		emailSubjectLine: petitionPageContactDm?.emailSubjectLine || '',
		emailBody: petitionPageContactDm?.emailBody || [''],
		emailEnabled: !!petitionPageContactDm?.emailEnabled,
	};

	return {
		legislativeBodiesEnabled: decisionMakersLegislativeBodies,
		dmWithLegislativeBodiesConnectionEnabled,
		contactDmConfig,
	};
};
